import { BASE_URL_VIEW } from '@src/domain/constants'

const invalidTokens = new Set(['undefined', 'null', 'none'])

const sanitizeAssetPath = (raw?: string | null): string | undefined => {
  if (raw === undefined || raw === null) {
    return undefined
  }

  const trimmed = String(raw).trim()
  if (!trimmed) {
    return undefined
  }

  const normalized = trimmed.replace(/\\/g, '/')
  const lowered = normalized.toLowerCase()

  if (invalidTokens.has(lowered)) {
    return undefined
  }

  if (lowered === '/' || lowered === './' || lowered === '#') {
    return undefined
  }

  if (lowered.startsWith('undefined') || lowered.startsWith('null')) {
    return undefined
  }

  return normalized
}

const isAbsoluteUrl = (value: string) => /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(value) || value.startsWith('data:')

export const resolveAssetUrl = (path?: string | null): string | undefined => {
  const sanitized = sanitizeAssetPath(path)
  if (!sanitized) {
    return undefined
  }

  if (isAbsoluteUrl(sanitized)) {
    return sanitized
  }

  const base = BASE_URL_VIEW?.trim()
  if (!base) {
    return sanitized
  }

  const normalizedBase = base.replace(/\/+$/, '')
  const normalizedPath = sanitized.replace(/^\/+/, '')

  if (!normalizedPath) {
    return undefined
  }

  return `${normalizedBase}/${normalizedPath}`
}

export const getAssetUrl = (path?: string | null, fallback?: string): string | undefined => {
  return resolveAssetUrl(path) ?? fallback
}

export const hasValidAssetUrl = (path?: string | null): boolean => {
  return Boolean(resolveAssetUrl(path))
}
